import RateCodeControl from 'features/CustomCampaigns/RateCodeFilter/RateCodeControl'
import RateCodeRow from 'features/CustomCampaigns/RateCodeFilter/RateCodeRow'

import styles from './SelectedCodes.module.scss'

const SelectedCodes = ({ onClickCode, removeAllCodes, selectedRateCodes }) => (
  <div className={styles.wrapper}>
    <div className={styles.header}>
      <div className={styles.titleHolder}>
        <h2 className={styles.title}>Selected rate codes</h2>
        <p className={styles.titleDescription}>
          {Object.keys(selectedRateCodes).length} rate codes selected
        </p>
      </div>
    </div>
    <div className={styles.contentHolder}>
      {!Object.keys(selectedRateCodes).length && (
        <div className={styles.notFoundHolder}>
          <span className={styles.notFoundText}>Add rate codes from left side</span>
        </div>
      )}
      {Object.keys(selectedRateCodes).map(rateCode => (
        <RateCodeRow
          rateCode={rateCode}
          key={rateCode}
          count={selectedRateCodes[rateCode]}
          action="remove"
          onClick={() => onClickCode({ rateCode })}
        />
      ))}
    </div>
    {Object.keys(selectedRateCodes).length > 1 && (
      <RateCodeControl action="remove" onClick={removeAllCodes} />
    )}
  </div>
)

export default SelectedCodes
